/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var PropTypes = require("prop-types");
var classnames = require("classnames");
if (!process.env.ALEX_UI_IGNORE_CSS) { require('./NestedView.css'); }
var moduleClassNameFactory_1 = require("./util/moduleClassNameFactory");
var scrollTopAnimated_1 = require("./util/scrollTopAnimated");
var moduleClassName = moduleClassNameFactory_1.moduleClassNameFactory("m-nestedView");
var filterFalsyChildren = function (children) {
    return React.Children.toArray(children).filter(function (item) { return !!item; });
};
var NestedView = /** @class */ (function (_super) {
    tslib_1.__extends(NestedView, _super);
    function NestedView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            cachedNestedView: null
        };
        _this.isTransitioning = false;
        _this.scroller = null;
        _this.handleTransitionEnd = function () {
            if (_this.transitionEndTimeout) {
                clearTimeout(_this.transitionEndTimeout);
            }
            _this.setState({
                cachedNestedView: null
            });
        };
        return _this;
    }
    NestedView.prototype.componentWillReceiveProps = function (nextProps) {
        var nextChildrenLength = filterFalsyChildren(nextProps.children).length;
        var currentChildrenLength = filterFalsyChildren(this.props.children)
            .length;
        if (nextChildrenLength !== currentChildrenLength) {
            this.resetScrollTop();
            if (nextChildrenLength < currentChildrenLength) {
                this.setState({
                    cachedNestedView: React.Children.toArray(this.props.children).pop()
                });
            }
        }
    };
    NestedView.prototype.resetScrollTop = function () {
        if (this.scroller) {
            // Find a parent that was scrolled
            var parentElement = this.scroller;
            var maxRecursions = 5; // Safety Belt.
            while (parentElement.parentElement && maxRecursions >= 0) {
                if (parentElement && parentElement.scrollTop > 0) {
                    // And scroll it back up
                    scrollTopAnimated_1.scrollTopAnimated(parentElement, 0);
                    break;
                }
                parentElement = parentElement.parentElement;
                maxRecursions--;
            }
        }
    };
    NestedView.prototype.componentWillUnmount = function () {
        if (this.transitionEndTimeout) {
            clearTimeout(this.transitionEndTimeout);
        }
    };
    NestedView.prototype.scheduleTransitionEndTimeout = function () {
        this.transitionEndTimeout = window.setTimeout(this.handleTransitionEnd, 500);
    };
    NestedView.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, className = _a.className, props = tslib_1.__rest(_a, ["children", "className"]);
        var pageTotalCount = React.Children.toArray(children).length;
        var percentage = pageTotalCount === 1 ? 0 : -100 * (pageTotalCount - 1);
        return (React.createElement("div", tslib_1.__assign({ className: classnames(moduleClassName(), className) }, props),
            React.createElement("div", { ref: function (elem) { return (_this.scroller = elem); }, className: classnames(moduleClassName("scroller")), onTransitionEnd: this.handleTransitionEnd, style: {
                    transform: "translateX(" + percentage + "%)",
                    willChange: this.isTransitioning ? "transform" : undefined
                } },
                React.Children.map(children, function (child, index) {
                    if (!child) {
                        return child;
                    }
                    var castedChild = child;
                    return React.cloneElement(castedChild, {
                        className: classnames(index < pageTotalCount - 1 && moduleClassName("page-isTail"), castedChild.props.className)
                    });
                }),
                this.state.cachedNestedView)));
    };
    NestedView.propTypes = {
        className: PropTypes.string
    };
    return NestedView;
}(React.Component));
exports.NestedView = NestedView;
exports.NestedViewPage = function NestedViewPage(_a) {
    var children = _a.children, className = _a.className, props = tslib_1.__rest(_a, ["children", "className"]);
    return (React.createElement("div", { className: classnames(moduleClassName("page"), className) }, children));
};
exports.NestedViewPage.propTypes = {
    className: PropTypes.string
};